export const handleValidNumber2  = (event : any) =>{
    const PinRegExp = /^[0-9]*$/
    if (PinRegExp.test(event?.target?.value)) {
        return true
    }
    else {
        return false

    }
} 

export const handleValidDecimalNumber = (event: any) => {
  const DecimalRegExp = /^\d*\.?\d*$/;
  return DecimalRegExp.test(event?.target?.value);
};